import React, { useEffect, useRef } from 'react'
import Box from '@mui/material/Box'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import StepConnector from '@mui/material/StepConnector'
import Typography from '@mui/material/Typography'
import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded'
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded'
import { StepSelection } from './step-selection'
import { StepDistribution } from './step-distribution'
import { useRoutingContext } from '../../hooks/use-routing-context'
import ErrorBox from '@/components/shared/boxes/ErrorBox'


const STEPS = [
  {
    label: 'Seleção',
    icon: <ChecklistRoundedIcon />,
    content: <StepSelection key={0} />
  },
  {
    label: 'Distribuição',
    icon: <GroupsRoundedIcon />,
    content: <StepDistribution key={1} />
  }
]

const Steps: React.FC = () => {
  const { activeStep, selectionError, setSelectionError } = useRoutingContext()
  const errorRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (selectionError) {
      errorRef.current?.scrollIntoView?.({ behavior: 'smooth', block: 'center' })
    }
  }, [selectionError])

  return (
    <>
      <Stepper
        activeStep={activeStep}
        sx={{ p: 3, bgcolor: 'background.header', borderRadius: 2, justifyContent: 'center' }}
        connector={<StepConnector sx={{ maxWidth: 50 }} />}
        data-testid="routing-create-steps"
      >
        {STEPS.map((props, index) => {
          const color = activeStep === index ? 'primary.main' : activeStep > index ? 'text.primary' : 'text.disabled'
          return (
          <Step key={index}>
            <StepLabel icon={props.icon} sx={{ color }} >
              <Typography variant="h6" color={color}>
                {props.label}
              </Typography>
            </StepLabel>
          </Step>
        )})}
      </Stepper>
      {selectionError && (
        <Box ref={errorRef}>
          <ErrorBox title={selectionError.reason} errorMessage={selectionError.message} onClose={() => setSelectionError(null)} />
        </Box>
      )}
      <Box>
        {STEPS[activeStep].content}
      </Box>
    </>
  )
}

export default Steps
